
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import axiosInstance from '../axiosInterceptor';
import { FaEye, FaEyeSlash } from "react-icons/fa";

const EmailSetting = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [data, setData] = useState({
        email: '',
        password: '',
        host: '',
        port: '',
        toEmail: '',
        bccEmail: '',
        ccEmail: '',
    });

    const [errors, setErrors] = useState({
        email: '',
        password: '',
        host: '',
        port: '',
    });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await axiosInstance.get(`emailsetting/getEmailSetting`);
            const { data } = response.data;
            setData({ ...data });
        } catch (error) {
            toast.error(
                error?.response?.data?.message ||
                "Something went wrong. Please try again!"
            );
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData(prevData => ({ ...prevData, [name]: value }));
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        // Validation for required fields
        let hasErrors = false;
        const newErrors = {};

        if (!data.email) {
            newErrors.email = "Email is required";
            hasErrors = true;
        }
        if (!data.password) {
            newErrors.password = "Password is required";
            hasErrors = true;
        }
        if (!data.host) {
            newErrors.host = "Host is required";
            hasErrors = true;
        }
        if (!data.port) {
            newErrors.port = "Port is required";
            hasErrors = true;
        }

        setErrors(newErrors);

        if (hasErrors) return;

        const newData = { ...data };
        if (newData._id) {
            delete newData._id;
            delete newData.createdAt;
            delete newData.updatedAt;
            delete newData.__v;
        }
        try {
            const response = await axiosInstance.put(`emailsetting/updateEmailSetting`, newData);
            if (response.status === 200) {
                toast.success(response.data.message);
                fetchData();
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(
                error?.response?.data?.message ||
                "Something went wrong. Please try again!"
            );
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className="content-wrapper">
            <div className="page-header mt-5 mx-4">
                <h3 className="page-title">Email Settings </h3>
            </div>
            <div className="col-md-12 grid-margin stretch-card">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <form className="pt-3" onSubmit={handleUpdate}>
                                <div className="page-header mb-2">
                                    <h2 className="page-title">Sender </h2>
                                </div>
                                <div className='row'>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label
                                                htmlFor="exampleInputUsername2"
                                                className="col-form-label"
                                            >
                                                Email
                                            </label>
                                            <input
                                                type="email"
                                                className="form-control form-control-sm"
                                                id="email"
                                                name="email"
                                                placeholder="Enter email"
                                                value={data.email}
                                                onChange={handleChange}
                                            />
                                            {errors.email && <p className="text-danger">{errors.email}</p>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label
                                                htmlFor="password"
                                                className="col-form-label"
                                            >
                                                App Password
                                            </label>
                                            <div className="input-group">
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    className="form-control form-control-sm"
                                                    id="password"
                                                    name="password"
                                                    placeholder="Enter password"
                                                    value={data.password}
                                                    onChange={handleChange}
                                                />
                                                <div className="input-group-append">
                                                    <span
                                                        className="input-group-text"
                                                        onClick={togglePasswordVisibility}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        {showPassword ? <FaEye className='fs-5' /> : <FaEyeSlash className='fs-5' />}
                                                    </span>
                                                </div>
                                            </div>
                                            {errors.password && <p className="text-danger">{errors.password}</p>}
                                        </div>

                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label
                                                htmlFor="exampleInputUsername2"
                                                className="col-form-label"
                                            >
                                                SMTP Host
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="host"
                                                name="host"
                                                placeholder="Enter host"
                                                value={data.host}
                                                onChange={handleChange}
                                            />
                                            {errors.host && <p className="text-danger">{errors.host}</p>}
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label
                                                htmlFor="exampleInputUsername2"
                                                className="col-form-label"
                                            >
                                                Port
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                id="port"
                                                name="port"
                                                placeholder="Enter port"
                                                value={data.port}
                                                onChange={handleChange}
                                            />
                                            {errors.port && <p className="text-danger">{errors.port}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="page-header mt-4 mb-2">
                                    <h2 className="page-title">Receivers </h2>
                                </div>
                                <div className='row'>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label
                                                htmlFor="exampleInputUsername2"
                                                className="col-form-label"
                                            >
                                                To Email (Enquiry)
                                            </label>
                                            <input
                                                type="email"
                                                className="form-control form-control-sm"
                                                id="toEmail"
                                                name="toEmail"
                                                placeholder="Enter to email"
                                                value={data.toEmail}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label
                                                htmlFor="exampleInputUsername2"
                                                className="col-form-label"
                                            >
                                                BCC Email
                                            </label>
                                            <input
                                                type="email"
                                                className="form-control form-control-sm"
                                                id="bccEmail"
                                                name="bccEmail"
                                                placeholder="Enter bcc email"
                                                value={data.bccEmail}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label
                                                htmlFor="exampleInputUsername2"
                                                className="col-form-label"
                                            >
                                                CC Email
                                            </label>
                                            <input
                                                type="email"
                                                className="form-control form-control-sm"
                                                id="ccEmail"
                                                name="ccEmail"
                                                placeholder="Enter cc email"
                                                value={data.ccEmail}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className='text-start mt-4'>
                                    <Link to="/dashboard">
                                        <button className="btn btn-secondary mr-2">
                                            Back
                                        </button>
                                    </Link>
                                    <button type="submit" className="btn btn-success">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmailSetting;